module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-05b4d731!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/Reports/ReportDiscussionTab.vue
// module id = 2252
// module chunks = 61